import { Component, OnInit } from '@angular/core';
import { ContactsService } from 'app/services/home/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(private contactService:ContactsService) { }

  public admin = "";
  public adminEmail = "";
  public adminEmailTo = "";
  public supportEmail = "";
  public supportEmailTo = "";

  ngOnInit(): void {
    this.contactService.getContactInfo().subscribe(
      response => {this.admin = response.administrator;
        this.adminEmail = response.adminEmail;
        this.adminEmailTo = response.adminEmailTo;
        this.supportEmail = response.supportEmail;
        this.supportEmailTo = response.supportEmailTo;
      },
      error => console.log('error', error)
     );

  }

}
